// Define endpoints
const endpoints = {
  auth: {
    acceptAffiliateInvite: {
      segment: 'affiliates/invite/{inviteId}/accept',
      type: 'POST',
    },
    authorizeLogin: {
      segment: 'api/v1/user/verify-device',
      type: 'GET',
    },
    changeInstance: {
      segment: 'api/v1/user/change-instance',
      type: 'POST',
    },
    changeUsername: {
      segment: 'api/v1/user/change-username',
      type: 'POST',
    },
    countriesList: {
      segment: `api/v1/info/countries?platformUuid=1efdfeb8-a14a-4eac-b66d-6c4929e4376c`,
      type: 'GET',
    },
    domainInfo: {
      segment: `api/v1/public/domain-info?domain=${window.location.hostname.replace(/account/, 'my')}`,
      type: 'GET',
    },
    facebookOAuth: {
      segment: 'oauth/facebook/id-token/sign-in',
      type: 'POST',
    },
    forgotPassword: {
      segment: 'api/v1/user/forgot-password',
      type: 'POST',
    },
    getAffiliateInvite: {
      segment: 'affiliates/invite/{inviteId}',
      type: 'GET',
    },
    getCanChangeInstance: {
      segment: 'api/v1/user/can-change-instance',
      type: 'GET',
    },
    getProfile: {
      segment: 'api/v1/user/profile',
      type: 'GET',
    },
    googleOAuth: {
      segment: 'oauth/google/id-token/sign-in',
      type: 'POST',
    },
    location: {
      segment: 'api/v1/info/location',
      type: 'GET',
    },
    login: {
      segment: 'api/v1/user/login',
      type: 'POST',
    },
    logout: {
      segment: 'api/v1/user/logout',
      type: 'GET',
    },
    recaptcha: {
      segment: 'api/v1/user/login/recaptcha-required',
      type: 'GET',
    },
    recaptchaSignup: {
      segment: 'api/v1/user/register/recaptcha-required',
      type: 'GET',
    },
    registration: {
      segment: 'api/v2/user/register',
      type: 'POST',
    },
    requestValidationEmail: {
      segment: 'api/v1/user/request-validation-email',
      type: 'GET',
    },
    resetPassword: {
      segment: 'api/v1/user/reset-password',
      type: 'POST',
    },
    saveUnverifiedMobile: {
      segment: 'api/v1/user/mobile',
      type: 'POST',
    },
    twitterAuthorizeToken: {
      segment: 'oauth/twitter/id-token/authorize',
      type: 'POST',
    },
    twitterOAuth: {
      segment: 'oauth/twitter/id-token/sign-in',
      type: 'POST',
    },
    twitterRequestToken: {
      segment: 'oauth/twitter/id-token/request?app=gateway',
      type: 'POST',
    },
    validateEmail: {
      segment: 'api/v1/user/validate-email',
      type: 'POST',
    },
    validateMobile: {
      segment: 'api/v1/mobile/validate',
      type: 'GET',
    },
  },
  ipApi: {
    getip: {
      segment: 'ip',
      type: 'GET',
    },
    url: 'https://www.trackip.net/',
  },
};

// Change apiUrl based on env
const conf = {
  endpoints,
  mainUrl: process.env.REACT_APP_MAIN_URL,
};

export default conf;
